export default "<div id=\"container\">\n\t<mat-spinner\n\t\tclass=\"spinner\"\n\t\tmode=\"indeterminate\">\n\t</mat-spinner>\n</div>\n\t"